const r4uPureProfiles = ['PCR-A', 'PCR-B', 'TMC-A', 'TMC-B']

export const useR4UCustomer = () => {
  const isR4UPureCustomer = customer =>
    r4uPureProfiles.some(profile => customer?.profileType === profile)

  return {
    isR4UPureCustomer
  }
}
